import { createStore, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { routerMiddleware } from 'connected-react-router';
import createAppReducer from './reducers';
import { imminentlySaga } from './sagas';
// import { USER_LOGOUT } from './actions';

export default ({
  dataProvider,
  history,
  customReducers = {},
  authProvider = null,
  analyticsProvider = null,
  customSagas = [],
  initialState = {},
  config = {},
  customMiddleware = [],
}) => {
  const sagaMiddleware = createSagaMiddleware();
  const appReducer = createAppReducer(customReducers, history);
  // @ts-ignore
  const resettableAppReducer = (state, action) => appReducer(state, action);
  const saga = function* rootSaga() {
    yield all([
      imminentlySaga(dataProvider, authProvider, analyticsProvider, config),
      // @ts-ignore
      ...customSagas.map(saga => () => saga.call(this, authProvider, dataProvider)),
    ].map(fork));
  };

  const typedWindow = window;

  const store = createStore(
    resettableAppReducer,
    initialState,
    compose(
      applyMiddleware(
        sagaMiddleware,
        routerMiddleware(history),
        ...customMiddleware,
      ),
      // 
      // typeof typedWindow !== 'undefined'
      //   && typedWindow.__REDUX_DEVTOOLS_EXTENSION__
      //   ? typedWindow.__REDUX_DEVTOOLS_EXTENSION__()
      //   : (f) => f,
    ),
  );
  sagaMiddleware.run(saga);
  return store;
};
